import React from 'react';
import { useForm } from 'react-hook-form';
import { Box } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import useInputAttributes from 'hooks/useInputAttributes';
import { useTranslation } from 'localization';

import { Uploader } from 'components';
import { yup } from 'utils';

import BorderedBox from '../../../ProfileTab/components/BorderedBox';

const CorporateFrom: React.FC = () => {
  const { t } = useTranslation('component.settings.verification');

  const [selectedFile, setSelectedFile] = React.useState<
    Array<File & { preview: string }>
  >([]);

  const schema = yup.object().shape({
    file: yup.string().label(t('form.file')).required(),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const onSubmit = async (data: { file: string }) => {
    //
  };

  const formProps = useInputAttributes(register, errors, {
    file: t('form.file'),
  });

  return (
    <BorderedBox title={t('corporateDocuments')} w="100%">
      <Box as="form" onSubmit={handleSubmit(onSubmit)} w="100%">
        <Uploader
          {...formProps.file}
          label=""
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
          getValue={(value) => setValue('file', value)}
        />
      </Box>
    </BorderedBox>
  );
};

export default CorporateFrom;
